var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1670",
    "data-name": "Caminho 1670",
    d: "M24,48h0A24,24,0,0,1,0,24H0A24,24,0,0,1,24,0h0A24,24,0,0,1,48,24h0A24,24,0,0,1,24,48Z",
    fill: "#25d366"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2495",
    "data-name": "Grupo 2495",
    transform: "translate(8.165 8.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WA_Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2494",
    "data-name": "Grupo 2494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1671",
    "data-name": "Caminho 1671",
    d: "M197.162,175.427a15.776,15.776,0,0,0-24.826,19.032l-2.237,8.174,8.362-2.194A15.732,15.732,0,0,0,186,202.36h0a15.783,15.783,0,0,0,11.16-26.933ZM186.007,199.7h0a13.07,13.07,0,0,1-6.672-1.829l-.48-.283-4.963,1.3,1.325-4.838-.312-.494a13.11,13.11,0,1,1,11.107,6.144Zm7.19-9.821c-.394-.2-2.333-1.152-2.693-1.282s-.624-.2-.888.2-1.018,1.282-1.248,1.546-.461.3-.854.1a10.721,10.721,0,0,1-3.168-1.958,11.969,11.969,0,0,1-2.194-2.731c-.23-.394-.024-.61.173-.806.178-.178.394-.461.59-.691a2.628,2.628,0,0,0,.394-.658.726.726,0,0,0-.034-.691c-.1-.2-.888-2.136-1.214-2.928-.322-.768-.643-.662-.888-.677s-.494-.014-.754-.014a1.45,1.45,0,0,0-1.051.494,4.425,4.425,0,0,0-1.378,3.288,7.649,7.649,0,0,0,1.608,4.075c.2.264,2.779,4.243,6.734,5.952a22.524,22.524,0,0,0,2.246.83,5.381,5.381,0,0,0,2.482.158,4.066,4.066,0,0,0,2.659-1.872,3.334,3.334,0,0,0,.23-1.872C193.855,190.173,193.591,190.077,193.2,189.875Z",
    transform: "translate(-170.1 -170.8)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.abdc5c44832686837e64e032f64503fe.svg";
export { ForwardRef as ReactComponent };